module.exports = __webpack_public_path__ + "media/audio4.fbdda820.mp3";